import { render, staticRenderFns } from "./89.vue?vue&type=template&id=be145f04&scoped=true&"
import script from "./89.vue?vue&type=script&lang=js&"
export * from "./89.vue?vue&type=script&lang=js&"
import style0 from "./89.vue?vue&type=style&index=0&id=be145f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be145f04",
  null
  
)

export default component.exports